module.exports = __webpack_public_path__ + "img/tickets-big.9b64800f.png";